import { render, staticRenderFns } from "./TaskMessages.vue?vue&type=template&id=6e82aa6e&lang=pug&"
import script from "./TaskMessages.vue?vue&type=script&lang=js&"
export * from "./TaskMessages.vue?vue&type=script&lang=js&"
import style0 from "./TaskMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports